import React from 'react';
import { useLanguage } from '../../../contexts/LanguageContext';
import { formatDate, formatTimeFromHKT } from './utils/appointmentUtils';

const AppointmentOfferEventValue = ({ event }) => {
  const { t } = useLanguage();
  const { value, id } = event;

  const slot = value?.slot || {};
  const doctor = value?.doctor || {};

  return (
    <div className="space-y-1 text-sm">
      <div className="font-medium text-blue-600">
        🗓️ {t('appointmentOffer.title')}
      </div>
      {doctor.primary_name && (
        <div>👨‍⚕️ {t('appointmentOffer.doctor')}: {doctor.primary_name}</div>
      )}
      {doctor.speciality && (
        <div>🏥 {t('appointmentOffer.specialty')}: {doctor.speciality}</div>
      )}
      {slot.date && (
        <div>📅 {t('appointmentOffer.date')}: {formatDate(slot.date)}</div>
      )}
      {slot.start_time_hkt && slot.end_time_hkt && (
        <div>🕐 {t('appointmentOffer.time')}: {formatTimeFromHKT(slot.start_time_hkt)} - {formatTimeFromHKT(slot.end_time_hkt)}</div>
      )}
      {slot.location_code && (
        <div>📍 {t('appointmentOffer.location')}: {slot.location_code}</div>
      )}

      {/* 系統資訊 */}
      {(value?.appointment_info_id || id) && (
        <div className="space-y-1">
          <div className="text-xs text-gray-500">{t('appointmentOffer.systemInfo')}:</div>
          {value?.appointment_info_id && (
            <div className="text-xs text-gray-500">📋 {t('appointmentOffer.appointmentInfoId')}: {value.appointment_info_id}</div>
          )}
          {id && (
            <div className="text-xs text-gray-500">🗓️ {t('appointmentOffer.appointmentOfferId')}: {id}</div>
          )}
        </div>
      )}
    </div>
  );
};

export default AppointmentOfferEventValue;
